<template>
    <div>
        <b-form @submit.prevent="saveRuleTipPrudence()" data-vv-scope="formRuleTipPrudence">
            <b-row>
                <b-col md="12">
                    <b-form-group>
                        <label>Nombre <span class="text-danger">*</span></label>
                        <b-form-input v-model="ruleTipPrudence.name" type="text" class="form-control" name="name"
                            v-validate="'required'" data-vv-as=" " />
                        <span class="text-danger small" v-text="errors.first('formRuleTipPrudence.name')" />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <b-form-group>
                        <label>Consejos de prudencia que conforman la regla <span class="text-danger">*</span></label>
                        <el-select @change="toggleCombination"
                            v-model="ruleTipPrudence.sga_prudence_tip_code_combination_ids" clearable filterable
                            multiple size="medium" placeholder="Seleccionar consejo de prudencia"
                            name="sga_prudence_tip_code_combination_ids" v-validate="'required'" data-vv-as="">
                            <el-option v-for="item in activeTipsPrudenceSga" :key="item.id"
                                :label="item.code + ' - ' + item.name" :value="item.id" />
                        </el-select>
                        <span class="text-danger small"
                            v-text="errors.first('formRuleTipPrudence.sga_prudence_tip_code_combination_ids')" />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <b-form-group>
                        <label>Consejos de prudencia a mostrar <span class="text-danger">*</span></label>
                        <el-select v-model="ruleTipPrudence.sga_prudence_tip_code_display_ids" clearable filterable
                            multiple size="medium" placeholder="Seleccionar consejo de prudencia"
                            name="sga_prudence_tip_code_display_ids" v-validate="'required'" data-vv-as="">
                            <el-option v-for="item in prudenceTipCodeDisplays" :key="item.id"
                                :label="item.code + ' - ' + item.name" :value="item.id"/>
                        </el-select>
                        <span class="text-danger small"
                            v-text="errors.first('formRuleTipPrudence.sga_prudence_tip_code_display_ids')" />
                    </b-form-group>
                </b-col>

                <b-col md="12" class="mt-3 d-flex justify-content-end align-items-center">
                    <b-form-group>
                        <b-button variant="danger" @click="cancelRuleTipPrudence">
                            <i class="fa fa-reply"></i>
                            <span class="ml-1" v-text="'Cancelar'"></span>
                        </b-button>
                        <b-button type="submit" variant="primary" class="mx-1">
                            <i class="fa fa-save"></i>
                            <span class="ml-1" v-text="'Guardar'"></span>
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-form>

    </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
export default {
    name: 'FormRulesTipsPrudence',
    data() {
        return {
            prudenceTipCodeDisplays: [],
        };
    },

    computed: {
        ...mapState('sgaRulesTipsPrudence', ['action', 'ruleTipPrudence']),
        ...mapState('sgaTipsPrudence', ['activeTipsPrudenceSga']),
        ...mapState('sgaVersions', ['activeGlobalVersion']),
    },

    async created() {
        await this.getActiveTipsPrudenceSga();
        this.toggleCombination();
    },
    methods: {
        ...mapActions('sgaRulesTipsPrudence', ['createRuleTipPrudenceSga', 'getRulesTipsPrudenceSga', 'updateRuleTipPrudenceSga']),
        ...mapMutations('sgaRulesTipsPrudence', ['setDefaultRuleTipPrudenceSga']),
        ...mapActions('sgaTipsPrudence', ['getActiveTipsPrudenceSga']),

        cancelRuleTipPrudence() {
            this.setDefaultRuleTipPrudenceSga();
            this.$bvModal.hide('modal_create_rules_tips_prudence');
        },

        async cancelAndGetRulesTipPrudence() {
            this.cancelRuleTipPrudence();
            await this.getRulesTipsPrudenceSga();
        },

        async saveRuleTipPrudence() {
            const isValid = await this.$validator.validateAll('formRuleTipPrudence');
            if (!isValid) return;

            this.ruleTipPrudence.version_id = this.activeGlobalVersion;

            let flag = false;
            if (this.action === 'edit') {
                flag = await this.updateRuleTipPrudenceSga(this.ruleTipPrudence);
            } else {
                flag = await this.createRuleTipPrudenceSga(this.ruleTipPrudence);
            }

            if (flag) {
                this.cancelAndGetRulesTipPrudence();
            }
        },

        // Listar los consejos de prudencia a mostrar a partir de la combinación de consejos de prudencia
        toggleCombination() {
            this.prudenceTipCodeDisplays = this.activeTipsPrudenceSga.filter((item) => {
                return this.ruleTipPrudence.sga_prudence_tip_code_combination_ids.includes(item.id);
            });
        },
    }
}
</script>
